export interface ExploreForm {
  handedness: number;
  pet_preference: number;
  hours_sleep_actual: number;
  hours_sleep_desirable: number;
  lateralization: number;
  like_to_draw: number;
  like_math: number;
}

export class ExploreStateModel {
  form: ExploreForm;
  step: number;
  loading: boolean;
  loaded: boolean;
}
